/** Statuses returned by usp_get_gas_pipelines (server-filtered). */
export const ACTIVE_GAS_PIPELINE_STATUSES = ['operating', 'construction'];

export const GAS_PIPELINE_STATUS_COLORS = {
  operating: '#2ecc71',
  construction: '#f39c12',
};

export const GAS_PIPELINES_MASTER_LAYER_KEY = 'gasPipelines';

export function getGasLayerKey(status) {
  const norm = String(status || 'unknown').trim().toLowerCase();
  return `gasPipelines__${norm}`;
}

export function isGasPipelineLayerKey(layerKey) {
  return typeof layerKey === 'string' && layerKey.startsWith('gasPipelines__');
}

export function getGasStatusLayerKeys(statistics) {
  const byStatus = statistics?.by_status || {};
  return ACTIVE_GAS_PIPELINE_STATUSES
    .filter((status) => (byStatus[status] ?? 0) > 0)
    .map((status) => getGasLayerKey(status));
}

export function isGasLayerVisible(layerVisibility, layerKey, gasMasterOn) {
  if (!gasMasterOn || !isGasPipelineLayerKey(layerKey)) return false;
  return layerVisibility[layerKey] !== false;
}

export function gasPipelineLayersNeedBuild(layerGroups, statusLayerKeys) {
  if (!layerGroups || !statusLayerKeys?.length) return true;
  return statusLayerKeys.some((layerKey) => {
    const group = layerGroups[layerKey];
    return !group || group.getLayers().length === 0;
  });
}

export function clearGasPipelineLayerGroups(layerGroups) {
  if (!layerGroups) return;
  Object.keys(layerGroups).forEach((key) => {
    if (isGasPipelineLayerKey(key) && layerGroups[key]?.clearLayers) {
      layerGroups[key].clearLayers();
    }
  });
}
